// extracted by mini-css-extract-plugin
export default {"letter":"Letter_letter__86vpu","letter__scrollbarWrapper":"Letter_letter__scrollbarWrapper__QoBNe","letter__comment":"Letter_letter__comment__bvUea"};